// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"c85a279c","168":"2af1e599","354":"b00712aa","369":"afe6da80","481":"f31323fb","488":"49ec70ef","600":"18bb8229","663":"d5436af8","695":"449d8ca5","721":"8816f1fc","856":"8a35f83e","924":"8b643d09"}[chunkId] + ".chunk.js";
};